(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kjs-native-store-stock"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('kjs-native-store-stock')) return;
    const locationIds = new Set([
      'gid://shopify/Location/58375733425',
      'gid://shopify/Location/58373472433'
    ]);
    const stockQuery = `query KjsRetailStoreStock($variantId: ID!) {
      node(id: $variantId) {
        ... on ProductVariant {
          storeAvailability(first: 20) {
            nodes { available quantityAvailable location { id name } }
            pageInfo { hasNextPage endCursor }
          }
        }
      }
    }`;
    const variantGid = (value) => {
      const id = String(value || '');
      if (/^[1-9]\d*$/.test(id)) return `gid://shopify/ProductVariant/${id}`;
      return /^gid:\/\/shopify\/ProductVariant\/[1-9]\d*$/.test(id) ? id : null;
    };
    const resourceId = (value) => String(value || '').split('/').pop();

    class KjsNativeStoreStock extends HTMLElement {
      constructor() {
        super();
        this.requestVersion = 0;
        this.onVariantChange = (event) => {
          const detail = event.detail || {};
          if (this.dataset.instanceId && String(detail.sectionId || '') === this.dataset.instanceId && resourceId(detail.productId) === this.dataset.productId) {
            this.load(detail.variantId);
          }
        };
        this.onRetry = () => this.load(this.variantId);
      }

      connectedCallback() {
        if (this.bound) return;
        this.status = this.querySelector('[data-stock-status]');
        this.retry = this.querySelector('[data-stock-retry]');
        this.badges = Array.from(this.querySelectorAll('[data-stock-location]'));
        if (!this.status || !this.retry || this.badges.length !== 2) return;
        this.bound = true;
        this.numberFormat = new Intl.NumberFormat(document.documentElement.lang || 'en');
        document.addEventListener('kjs:variant-change', this.onVariantChange);
        this.retry.addEventListener('click', this.onRetry);
        const section = this.closest('[data-section-id]');
        const selected = section && section.dataset.sectionId === this.dataset.instanceId
          ? section.querySelector(`[id="product-select-${this.dataset.productId}"]`)
          : null;
        this.load(selected ? selected.value : this.dataset.variantId);
      }

      disconnectedCallback() {
        this.requestVersion += 1;
        if (this.controller) this.controller.abort();
        clearTimeout(this.timeout);
        document.removeEventListener('kjs:variant-change', this.onVariantChange);
        if (this.retry) this.retry.removeEventListener('click', this.onRetry);
        this.bound = false;
      }

      clearQuantities() {
        for (const badge of this.badges) {
          badge.textContent = this.dataset.checkStore;
          badge.dataset.stockState = 'unknown';
        }
      }

      setState(state, message, retry = false) {
        this.dataset.stockState = state;
        this.setAttribute('aria-busy', state === 'loading' ? 'true' : 'false');
        this.status.textContent = message;
        this.retry.hidden = !retry;
      }

      async load(value) {
        const version = ++this.requestVersion;
        if (this.controller) this.controller.abort();
        clearTimeout(this.timeout);
        this.variantId = variantGid(value);
        this.clearQuantities();
        if (!this.variantId) {
          this.setState('unavailable', this.dataset.chooseVariant);
          return;
        }
        if (!this.dataset.token || !/^https:\/\/[a-z0-9][a-z0-9-]*\.myshopify\.com\/api\/2026-07\/graphql\.json$/.test(this.dataset.endpoint || '')) {
          this.setState('unavailable', this.dataset.unavailable);
          return;
        }
        const controller = new AbortController();
        this.controller = controller;
        this.setState('loading', this.dataset.loading);
        this.timeout = setTimeout(() => controller.abort(), 10000);
        try {
          const response = await fetch(this.dataset.endpoint, {
            method: 'POST',
            mode: 'cors',
            credentials: 'omit',
            cache: 'no-store',
            headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Storefront-Access-Token': this.dataset.token
            },
            body: JSON.stringify({query: stockQuery, variables: {variantId: this.variantId}}),
            signal: controller.signal
          });
          if (!response.ok) throw new Error('Stock request failed');
          const payload = await response.json();
          if (version !== this.requestVersion || !this.isConnected) return;
          if (payload.errors && payload.errors.length) throw new Error('Stock access failed');
          const connection = payload.data && payload.data.node && payload.data.node.storeAvailability;
          if (!connection || !Array.isArray(connection.nodes) || !connection.pageInfo || connection.pageInfo.hasNextPage !== false) {
            throw new Error('Incomplete stock response');
          }
          const quantities = new Map();
          for (const entry of connection.nodes) {
            const id = entry && entry.location && entry.location.id;
            if (!locationIds.has(id)) continue;
            if (quantities.has(id)) throw new Error('Duplicate stock location');
            quantities.set(id, Number.isSafeInteger(entry.quantityAvailable) && entry.quantityAvailable >= 0 ? entry.quantityAvailable : null);
          }
          for (const badge of this.badges) {
            const quantity = quantities.get(badge.dataset.stockLocation);
            if (quantity === 0) {
              badge.textContent = this.dataset.outOfStock;
              badge.dataset.stockState = 'empty';
            } else if (Number.isSafeInteger(quantity) && quantity > 0) {
              badge.textContent = this.dataset.quantityPattern.replace('__COUNT__', this.numberFormat.format(quantity));
              badge.dataset.stockState = 'in-stock';
            }
          }
          this.setState('ready', this.dataset.updated);
        } catch (_) {
          if (version === this.requestVersion && this.isConnected) {
            this.clearQuantities();
            this.setState('unavailable', this.dataset.unavailable, true);
          }
        } finally {
          if (version === this.requestVersion) clearTimeout(this.timeout);
        }
      }
    }
    customElements.define('kjs-native-store-stock', KjsNativeStoreStock);
  })();
  } catch(e) { console.error(e); }
})();

})();
